import React from 'react';

import YouTubeVideo from '../component/youtupeVideo';
export default class VideoGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = { videoGallery: [] };
  }
  componentDidMount() {
    debugger;
    fetch('https://srkbst.org/data/videoGallery.json')
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        this.setState({
          videoGallery: data
        })
        console.log('Fetched data:', data);
        // You can now use the data in your component state
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }
  render() {
    return (
      <>

        <div className="container-fluid">         
          < div className="row justify-content-around gy-4">
            <div className="col-lg-11 d-flex flex-column justify-content-center">
              <div className='row'>
                {/* Desktop view */}
                <div className='col-12 col-lg-12 d-none d-sm-block d-md-block d-lg-block d-xl-block'>
                  <h2 style={{ color: 'rgb(115, 20, 20)' }}>Video Gallery! </h2>
                </div>

                {
                  this.state.videoGallery.length > 0 && this.state.videoGallery.map((item, index) => {
                    return (
                      <div className='col-12 col-lg-6 video-gallery'>
                        <YouTubeVideo key={index} embedId={item.videoembedId} title={item.videoName} />
                      </div>
                    );
                  })
                }

              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}